import axios from "axios"
import { env } from "../env"

const api = axios.create({
  baseURL: env.apiUrl,
  withCredentials: true,
})

api.interceptors.request.use((cfg) => {
  try {
    const token = localStorage.getItem("token")
    if (token) {
      cfg.headers = cfg.headers || {}
      cfg.headers.Authorization = `Bearer ${token}`
    }
  } catch (_e) {
    // ignore
  }
  return cfg
})

export default api
